import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import interactionResponse from 'await-interaction-response';
import _get from 'lodash/get';
import _set from 'lodash/set';

import { useDevice } from '@bonnet/next/device';

import { pageNames } from '@atc/bonnet-paths';
import { useBrand } from '@atc/brand';
import { useFeatures } from '@atc/features';

import { sendClick } from 'reaxl-analytics';

import { hideAdClick } from '@/analytics/srp/hideAdEvents';

import adUnits from '@/config/adUnits';

import srpAdsDuck from '@/ducks/srp/srpAdsDuck.js';
import srpTowerAdDuck from '@/ducks/srp/srpTowerAdDuck.js';

import AtcAdSlot from '@/containers/AtcAdSlot';
import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

import HideAdButton from '@/components/HideAdButton';

const { SEARCH_RESULTS } = pageNames;

function SRLTowerAdSlotContainer() {
    const device = useDevice();
    const isLessThanMd = _get(device, 'lessThan.md', false);

    const { brands, isBrand } = useBrand();
    const isKbbBranded = isBrand(brands.KBB_BRAND);

    const dispatch = useDispatch();
    const hideTowerAd = useSelector(srpTowerAdDuck.selectors.getHideTowerAd);
    const adsLazyLoadingOffset = useSelector(srpAdsDuck.selectors.getAdsLazyLoadingOffset);
    const greaterThanMd = _get(device, 'greaterThan.md', false);

    const {
        ads: [, { srlTowerSlotId }],
        enable_hide_ad: [enableHideAd],
    } = useFeatures(['ads', 'enable_hide_ad']);

    const handleHideTowerAd = useCallback(async (event) => {
        const eventTarget = _get(event, 'target.value', null);
        await interactionResponse();
        _set(event, 'target.value', eventTarget);

        const extra = {
            adType: 'Tower Ad',
        };
        sendClick(hideAdClick, event, extra);
        dispatch(srpTowerAdDuck.creators.setKeys({
            hideTowerAd: true,
        }));
    }, [dispatch]);

    const path = `${adUnits?.atcFindcar}/srp`;

    // ensure ad sizes are in order from shortest to tallest to make sure min size is smallest height
    // Remove 300x600 on ATC-SRP and KBB-SRP - only desktop
    const size = greaterThanMd ? [[300, 250], [160, 600]] : [[160, 600]];

    const targeting = {
        anml: 'N',
        pos: !isKbbBranded ? 'g' : 'G',
        prd: 'dlr',
    };

    if (enableHideAd && hideTowerAd) {
        return null;
    }

    return (
        <DisableAdsFeatureFlag>
            {!isLessThanMd && (
                <div
                    className="margin-top-4"
                    style={{ position: 'sticky', top: '5rem' }}
                >
                    <AtcAdSlot
                        path={path}
                        showPlaceholder
                        size={size}
                        slotId={srlTowerSlotId}
                        targeting={targeting}
                        lazyLoading
                        lazyLoadingBottomOffset={adsLazyLoadingOffset}
                        lazyLoadingTopOffset={adsLazyLoadingOffset}
                        preserveSpace
                        adSelector={srpAdsDuck.selectors.getDuckState}
                        pageName={SEARCH_RESULTS}
                        advertisementLabel={{
                            className: 'display-flex justify-content-end',
                            text: 'Advertisement',
                            enableHide: enableHideAd,
                            hideButton: HideAdButton,
                            onClickHide: handleHideTowerAd,
                        }}
                    />
                </div>
            )}
        </DisableAdsFeatureFlag>
    );
}

export default SRLTowerAdSlotContainer;
